import { API } from "redux/api";

export function getMenu(data) {
  return API({
    method: "get",
    url: "/merchants/menu",
    params: data,
  });
}

// Update Item options
export function updateItemOptions(details) {
  return API({
    method: "post",
    url: "/merchants/updateMenu",
    params: details,
  });
}
